'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formUrl = exports.liveChatWithSales = exports.bundle = exports.suite = exports.partnerProgramPaywall = exports.productsAndAddons = exports.technicalConsultingBlock = exports.inboundConsultingBlock = exports.serviceProfessionalOnboarding = exports.salesProfessionalOnboarding = exports.serviceQuickStartConsultation = exports.serviceStarterKit = exports.serviceInPersonTraining = exports.serviceDesignatedTechnicalSupport = exports.addonTransactionalEmail = exports.addonAdditionalPortalLink = exports.addonDedicatedIp = exports.addonBrandDomain = exports.addonCrm = exports.addonCms = exports.addonWebsite = exports.addonAds = exports.addonReporting = exports.starterContacts = exports.servicePricing = exports.marketingPricing = exports.mapRedirectTargetToRoute = exports.upgradeiFrameLink = exports.paidUserManagementLink = exports.checkout = exports.salesPricing = exports.baseHubspotUrl = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _params = require('hub-http/helpers/params');

var _url = require('hub-http/helpers/url');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _LocalSettings = require('ui-addon-upgrades/_core/common/data/localData/LocalSettings');

var _LocalSettings2 = _interopRequireDefault(_LocalSettings);

var _upgradeProducts = require('../data/upgradeData/properties/upgradeProducts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pid = _hubspot2.default.get();
var suffix = _enviro2.default.getShort() === 'qa' ? 'qa' : '';

var baseUrlOptions = function baseUrlOptions() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'app';

  return {
    protocol: 'https',
    hostname: env + '.hubspot' + suffix + '.com'
  };
};
var formUrlOptions = {
  protocol: 'https',
  hostname: 'api.hsforms' + suffix + '.com'
};

var _createExternalUrl = function _createExternalUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isLocal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var urlOptions = _extends({}, baseUrlOptions(isLocal ? 'local' : 'app'), {
    path: path,
    query: (0, _params.stringify)(query)
  });

  return (0, _url.buildUrl)(urlOptions);
};

var _createUpgradeLink = function _createUpgradeLink() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments[1];

  if (params && !params.upgradeSource) {
    _devLogger2.default.warn({
      message: 'createUpgradeLink: Expected upgradeSource for path ' + path + ' but got ' + params.upgradeSource,
      key: 'createUpgradeLink: ' + path
    });
  }

  var urlOptions = _extends({}, baseUrlOptions(), {
    path: '/browse/' + pid + '/' + path,
    query: (0, _params.stringify)(params)
  });

  return (0, _url.buildUrl)(urlOptions);
};

var _createUpgradeLinkV2 = function _createUpgradeLinkV2() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments[1];

  if (params && !params.upgradeSource) {
    _devLogger2.default.warn({
      message: 'createUpgradeLink: Expected upgradeSource for path ' + path + ' but got ' + params.upgradeSource,
      key: 'createUpgradeLink: ' + path
    });
  }

  var urlOptions = _extends({}, baseUrlOptions(), {
    path: '/pricing/' + pid + '/' + path,
    query: (0, _params.stringify)(params)
  });

  return (0, _url.buildUrl)(urlOptions);
};

var baseHubspotUrl = exports.baseHubspotUrl = function baseHubspotUrl() {
  return (0, _url.buildUrl)(baseUrlOptions());
};

var salesPricing = exports.salesPricing = function salesPricing(upgradeSource) {
  return _createUpgradeLinkV2('sales', { upgradeSource: upgradeSource });
};

var checkout = exports.checkout = function checkout(orderId) {
  return _createExternalUrl('/checkout/' + pid + '/purchases/' + orderId);
};

var paidUserManagementLink = exports.paidUserManagementLink = function paidUserManagementLink() {
  return _createExternalUrl('/settings/' + pid + '/users/paid-users');
};

var upgradeiFrameLink = exports.upgradeiFrameLink = function upgradeiFrameLink() {
  var isUsingLocalEnv = _LocalSettings2.default.get('UPGRADE_IFRAME_ENV') === 'local';
  return _createExternalUrl('/upgrades-base/' + pid, {}, isUsingLocalEnv);
};

var redirectRoutes = {
  'landing-pages': '/pages/' + pid + '/manage/landing',
  email: '/email/' + pid + '/manage',
  'marketing-workflows': '/workflows/' + pid,
  'content-strategy': '/content-strategy/' + pid + '/clusters',
  'sales-workflows': '/workflows/' + pid,
  playbooks: '/playbooks/' + pid,
  sequences: '/sequences/' + pid,
  quotes: '/settings/' + pid + '/sales/products',
  tickets: '/contacts/' + pid + '/tickets/list/view/all',
  feedback: '/feedback/' + pid + '/home',
  'knowledge-base': '/knowledge/' + pid + '/insights/dashboard',
  'service-workflows': '/workflows/' + pid,
  meetings: '/meetings/' + pid,
  'user-settings': '/settings/' + pid + '/users?createUserEmail'
};

var mapRedirectTargetToRoute = exports.mapRedirectTargetToRoute = function mapRedirectTargetToRoute(redirectTarget, upgradeProduct) {
  if (redirectRoutes[redirectTarget]) {
    return redirectRoutes[redirectTarget];
  }

  var hub = upgradeProduct.split('-')[0];
  return upgradeProduct === _upgradeProducts.upgradeProducts.SALES_PROFESSIONAL ? '/getting-started/' + pid : '/reports-dashboard/' + pid + '/' + hub;
};

var marketingPricing = exports.marketingPricing = function marketingPricing(upgradeSource) {
  return _createUpgradeLinkV2('marketing', { upgradeSource: upgradeSource });
};

var servicePricing = exports.servicePricing = function servicePricing(upgradeSource) {
  return _createUpgradeLinkV2('service', { upgradeSource: upgradeSource });
};

var starterContacts = exports.starterContacts = function starterContacts() {
  var urlOptions = _extends({}, baseUrlOptions(), {
    path: '/pricing/' + pid + '/confirm-contacts?marketing-starter'
  });

  return (0, _url.buildUrl)(urlOptions);
};

var addonReporting = exports.addonReporting = function addonReporting(upgradeSource) {
  return _createUpgradeLink('upgrade/reporting', { upgradeSource: upgradeSource });
};

var addonAds = exports.addonAds = function addonAds(upgradeSource) {
  return _createUpgradeLink('upgrade/ads', { upgradeSource: upgradeSource });
};

var addonWebsite = exports.addonWebsite = function addonWebsite(upgradeSource) {
  return _createUpgradeLink('compare/website', { upgradeSource: upgradeSource });
};

var addonCms = exports.addonCms = function addonCms(upgradeSource) {
  return _createUpgradeLinkV2('cms', { upgradeSource: upgradeSource });
};

var addonCrm = exports.addonCrm = function addonCrm(upgradeSource) {
  return _createUpgradeLinkV2('crm', { upgradeSource: upgradeSource });
};

var addonBrandDomain = exports.addonBrandDomain = function addonBrandDomain(upgradeSource) {
  return _createUpgradeLink('upgrade/brand-domain', { upgradeSource: upgradeSource });
};

var addonDedicatedIp = exports.addonDedicatedIp = function addonDedicatedIp(upgradeSource) {
  return _createUpgradeLink('services/dedicated-ip', { upgradeSource: upgradeSource });
};

var addonAdditionalPortalLink = exports.addonAdditionalPortalLink = function addonAdditionalPortalLink(upgradeSource) {
  return _createUpgradeLink('services/add-on-portal', { upgradeSource: upgradeSource });
};

var addonTransactionalEmail = exports.addonTransactionalEmail = function addonTransactionalEmail(upgradeSource) {
  return _createUpgradeLink('services/transactional-email', { upgradeSource: upgradeSource });
};

var serviceDesignatedTechnicalSupport = exports.serviceDesignatedTechnicalSupport = function serviceDesignatedTechnicalSupport(upgradeSource) {
  return 'https://www.hubspot.com/services/consulting/technical?source=' + upgradeSource;
};

var serviceInPersonTraining = exports.serviceInPersonTraining = function serviceInPersonTraining(upgradeSource) {
  return 'https://www.hubspot.com/services/classroom-training?source=' + upgradeSource;
};

var serviceStarterKit = exports.serviceStarterKit = function serviceStarterKit(upgradeSource) {
  return _createUpgradeLink('services/starter-kit', { upgradeSource: upgradeSource });
};

var serviceQuickStartConsultation = exports.serviceQuickStartConsultation = function serviceQuickStartConsultation(upgradeSource) {
  return _createUpgradeLink('services/quick-start-consultation', {
    upgradeSource: upgradeSource
  });
};

var salesProfessionalOnboarding = exports.salesProfessionalOnboarding = function salesProfessionalOnboarding(upgradeSource) {
  return _createUpgradeLink('services/sales-professional-onboarding', {
    upgradeSource: upgradeSource
  });
};

var serviceProfessionalOnboarding = exports.serviceProfessionalOnboarding = function serviceProfessionalOnboarding(upgradeSource) {
  return _createUpgradeLink('services/service-professional-onboarding', {
    upgradeSource: upgradeSource
  });
};

var inboundConsultingBlock = exports.inboundConsultingBlock = function inboundConsultingBlock(upgradeSource) {
  return _createUpgradeLink('services/inbound-consulting-block', {
    upgradeSource: upgradeSource
  });
};

var technicalConsultingBlock = exports.technicalConsultingBlock = function technicalConsultingBlock(upgradeSource) {
  return _createUpgradeLink('services/technical-consulting-block', {
    upgradeSource: upgradeSource
  });
};

var productsAndAddons = exports.productsAndAddons = function productsAndAddons() {
  return _createUpgradeLinkV2();
};

// This paywall is where you'd go to upgrade to Partner status
var partnerProgramPaywall = exports.partnerProgramPaywall = function partnerProgramPaywall() {
  var urlOptions = _extends({}, baseUrlOptions(), {
    path: '/upgrade/' + pid + '/partner-program'
  });
  return (0, _url.buildUrl)(urlOptions);
};

var suite = exports.suite = function suite() {
  return _createUpgradeLinkV2('products/growth-suite');
};

var bundle = exports.bundle = function bundle() {
  return _createUpgradeLinkV2('bundle');
};

var liveChatWithSales = exports.liveChatWithSales = function liveChatWithSales() {
  return 'https://offers.hubspot.com/sales-pro-live-chat-product';
};

var formUrl = exports.formUrl = function formUrl(_ref) {
  var portalId = _ref.portalId,
      formId = _ref.formId;

  var urlOptions = _extends({}, formUrlOptions, {
    path: '/submissions/v3/integration/submit/' + portalId + '/' + formId
  });

  return (0, _url.buildUrl)(urlOptions);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/navigation/links.js
// module id = 129
// module chunks = 3 4 5